
import Vue from "vue";
import Onboarding from "@/components/molecules/OnBoarding.vue";
import { NolaAnalytics, NolaItemId } from "@/lib/utils/analytics";

interface StepData {
  targetSelector: string;
  message: string;
  tooltipPosition: string;
  highlightPadding: object;
  closeText: string;
  circle: boolean;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    currentStepIndex: {
      type: Number,
      default: 0,
    },
  },
  components: { Onboarding },
  data() {
    return {
      isVisible: true,
      steps: [
        {
          targetSelector: ".tutorial-agent",
          message: `<div style='font-size:16px;margin-bottom:16px;'>${this.$t('homePage.firstImportOnboarding.step1.messagePrefix')}<span style='color:#f1b700;'>${this.$t('homePage.firstImportOnboarding.step1.messageHighlight')}</span>${this.$t('homePage.firstImportOnboarding.step1.messageSuffix')}</div>`,
          tooltipPosition: "bottom-left",
          highlightPadding: { top: 6, bottom: 6, left: 6, right: 6 },
          closeText: this.$t('homePage.firstImportOnboarding.step1.closeText'),
        },
        {
          targetSelector: ".tutorial-novel-create",
          message: `<div style='font-size:16px;margin-bottom:6px;'><span style='color:#f1b700;'>${this.$t('homePage.firstImportOnboarding.step2.messageHighlight')}</span>${this.$t('homePage.firstImportOnboarding.step2.messageSuffix')}</div>`,
          tooltipPosition: "left-top",
          highlightPadding: { top: 0, bottom: 0, left: 0, right: 0 },
          closeText: this.$t('homePage.firstImportOnboarding.step2.closeText'),
          circle: true,
        },
      ] as StepData[],
      nolaAnalytics: new NolaAnalytics(this.$gtm, this.$store),
    };
  },
  computed: {
    currentStepData() {
      return this.steps[this.currentStepIndex] || null;
    },
  },
  methods: {
    nextStep() {
      if (this.currentStepIndex < this.steps.length - 1) {
        this.$emit("add-currentStepIndex");
      } else {
        this.isVisible = false;
        this.$emit("tutorial-completed");
      }
    },
    closeOnboarding() {
      this.nextStep();
      if (this.currentStepIndex === this.steps.length - 1) {
        // 閉じるのクリック
        this.nolaAnalytics.logButtonEvent(NolaItemId.TopOnboardingCreateClose);
      } else {
        // 次へのクリック
        this.nolaAnalytics.logButtonEvent(NolaItemId.TopOnboardingNext);
      }
    },
    outsideClicked() {
      this.isVisible = false;
      // step2で閉じるときは完了
      if (this.currentStepIndex === this.steps.length - 1) {
        this.$emit("tutorial-completed");
      } else {
        // step1で外側のクリックは通知する
        this.$emit("outside-clicked");
      }
      this.nolaAnalytics.logButtonEvent(NolaItemId.TopOnboardingCreateOutside);
    },
    onboardingTargetClicked() {
      this.$emit("tutorial-target-clicked", this.currentStepIndex);
      if (this.currentStepIndex === this.steps.length - 1) {
        // 新規作成のクリック
        this.nolaAnalytics.logButtonEvent(NolaItemId.TopOnboardingCreate);
      } else {
        // エージェントのクリック
        this.nolaAnalytics.logButtonEvent(NolaItemId.TopOnboardingAgent);
      }
    },
  },
});

interface Props {
  currentStepIndex: number;
}

interface Data {
  isVisible: boolean;
  steps: StepData[];
  nolaAnalytics: NolaAnalytics;
}

interface Computed {
  currentStepData: StepData | null;
}

interface Methods {
  nextStep(): void;
  closeOnboarding(): void;
  outsideClicked(): void;
  onboardingTargetClicked(): void;
}
